var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"loading":_vm.loading,"title":_vm.title,"extraLarge":"","hide-footer":""}},[_c('Form',{attrs:{"disable-filters":_vm.disableFilters},on:{"select":_vm.handleExit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }